export default {
      id: "sentiment-operator-negative-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#sentiment-operator-negative-usage",
      toString: function () {
        return this.url;
      }
    }